// Si tu archivo DEBE ser .ts (sin JSX directo):
import React from "react";
import { Product } from "../Models/Product";
import { 
  FaShieldHalved, 
  FaLayerGroup, 
  FaLock, 
  FaGem, 
  FaFeatherPointed, 
  FaSun 
} from "react-icons/fa6";

import { LuShield, LuSun, LuMinimize2, LuSmartphone, LuShieldAlert, LuSparkles } from "react-icons/lu";
import { LuFolderHeart, LuShieldCheck, LuLayers, LuFoldHorizontal } from "react-icons/lu"; // Puedes cambiar los iconos según tu librería
export const MOCK_PRODUCTS: Product[] = [
  {
    id: 1,
    name: "Basic Binder Card Aromory",
    img: "/images/binders.png",
    description: "Carpeta de almacenamiento básica con diseño ergonómico y correa de sujeción (strap), ideal para transportar y proteger tu colección de manera cómoda y segura.",
    colors: ["#1E293B", "#991B1B", "#15803D"],
    features: [
      {
        id: 101,
        icon: React.createElement(LuLayers, { className: "w-5 h-5 text-indigo-500" }),
        name: "Capacidad para 360 cartas"
      },
      {
        id: 102,
        icon: React.createElement(LuShieldCheck, { className: "w-5 h-5 text-amber-500" }),
        name: "Material libre de ácido y sin PVC"
      },
      {
        id: 103,
        icon: React.createElement(LuFolderHeart, { className: "w-5 h-5 text-emerald-500" }),
        name: "Páginas de carga con formato de 9 bolsillos (9-pocket)"
      }
    ]
  },
  {
    id: 2,
    name: "Herald Shield Deck Box",
    img: "/images/deck-box.png",
    description: "Deck box prémium de cuero sintético (PU) con dos exhibidores laterales para tus cartas favoritas. Su cubierta magnética es reconfigurable para facilitar el acceso rápido a tu mazo durante el juego.",
    colors: ["#0F172A", "#7C3AED", "#B45309"],
    features: [
      {
        id: 201,
        icon: React.createElement(LuShieldCheck, { className: "w-5 h-5 text-blue-500" }),
        name: "Material PU de alta calidad y acabado resistente"
      },
      {
        id: 202,
        icon: React.createElement(LuLayers, { className: "w-5 h-5 text-purple-500" }),
        name: "Capacidad para más de 120 cartas con folio/sleeve"
      },
      {
        id: 203,
        icon: React.createElement(LuFoldHorizontal, { className: "w-5 h-5 text-indigo-500" }),
        name: "Incluye 2 separadores para organizar tu mazo"
      }
    ]
  },
  {
    id: 3,
    name: "Ultra Thin Magnetic Card Protector 35pt",
    img: "/images/magnetico.png",
    description: "Protector magnético prémium de perfil ultra delgado (4.4 mm) diseñado para cartas de 35pt. Incorpora cierre magnético de alta fijación y protección UV para preservar los colores y el valor de tu colección.",
    colors: ["#111827", "#2563EB"],
    features: [
      {
        id: 301,
        icon: React.createElement(LuMinimize2, { className: "w-5 h-5 text-emerald-500" }),
        name: "Grosor de 35pt con diseño ultra delgado de 4.4 mm"
      },
      {
        id: 302,
        icon: React.createElement(LuSun, { className: "w-5 h-5 text-sky-500" }),
        name: "Filtro de protección UV para prevenir el desgaste y decoloración"
      },
      {
        id: 303,
        icon: React.createElement(LuShield, { className: "w-5 h-5 text-blue-500" }),
        name: "Cierre magnético de alta precisión y esquinas incrustadas"
      }
    ]
  },
    {
    id: 4,
    name: "PSA Slab Bumper Guard",
    img: "/images/psa.png",
    description: "Bumper protector con acrílico de cobertura para encuadres PSA. Diseñado con un sistema de fácil instalación que amortigua caídas, previene rayones y realza la presentación visual de tus slabs con un estilo único.",
    colors: ["#111827", "#2563EB"],
    features: [
      {
        id: 301,
        icon: React.createElement(LuShieldAlert, { className: "w-5 h-5 text-emerald-500" }),
        name: "Protección anti-caídas y absorción de impactos"
      },
      {
        id: 302,
        icon: React.createElement(LuSmartphone, { className: "w-5 h-5 text-sky-500" }),
        name: "Diseño con cubierta protectora e instalación rápida sin herramientas"
      },
      {
        id: 303,
        icon: React.createElement(LuSparkles, { className: "w-5 h-5 text-blue-500" }),
        name: "Acabado estético en variedad de colores para personalizar tu colección"
      }
    ]
  }
];